<template>
    <button
        class="nav-link btn btn-link symbol symbol-circle px-2 dm-report-issues-button"
        @click="openReportIssueModal()"
        data-cy="dm-report-issues-button"
    >
        <span class="d-block d-md-none"
            ><i class="las la-exclamation-triangle p-0"></i
        ></span>
        <span class="d-none d-md-block pr-2">{{
            translate("Report an Issue")
        }}</span>
    </button>
</template>

<script>
import { initializeTooltip } from "@/utilities/utilities.js";

export default {
    methods: {
        initializeTooltip,
        openReportIssueModal() {
            jQuery("#dm-report-issues-modal").modal();
        },
    },

    mounted() {
        this.initializeTooltip();
    },
};
</script>
